var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 50 50",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M12.8,8.5c0-2.1-1.7-3.9-3.9-3.9S5.1,6.4,5.1,8.5s1.7,3.9,3.9,3.9S12.8,10.6,12.8,8.5z M7.1,8.5 c0-1,0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9s-0.8,1.9-1.9,1.9C7.9,10.4,7.1,9.5,7.1,8.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M39.6,21.8c-7.2,0-11.7,7.8-8.1,14.1l6.1,10.6l-17.2-3.9l3-6.8c0.2-0.4,0.1-0.9-0.2-1.1l-13-12.1l5.6-9.7 C18.9,7.6,15,1,8.9,1C2.8,1-1,7.6,2.1,12.9l6,10.4c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0l13.1,12.1l-3.2,7.2c-0.1,0.3-0.1,0.6,0,0.9 c0.1,0.3,0.4,0.5,0.7,0.5c0.1,0,22.2,5,20.8,4.7c0,0,0,0,0,0c0.1,0,0.2,0,0.3-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1-0.1,0.2-0.1 c0,0,0.1,0,0.1-0.1c0.1,0,0.1-0.1,0.1-0.2c0,0,0,0,0.1-0.1c0,0,0,0,0,0l7.3-12.6C51.3,29.7,46.8,21.8,39.6,21.8z M8.9,3 c4.6,0,7.4,5,5.1,8.9l-5.1,8.9l-5.1-8.9C1.5,7.9,4.4,3,8.9,3z M46,34.9L39.6,46l-6.4-11.1c-2.8-4.9,0.7-11.1,6.4-11.1 C45.3,23.8,48.8,30,46,34.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#010101",
    d: "M39.6,26.2c-2.5,0-4.5,2-4.5,4.5s2,4.5,4.5,4.5s4.5-2,4.5-4.5S42.1,26.2,39.6,26.2z M39.6,33.2 c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.4,0,2.5,1.1,2.5,2.5C42.1,32.1,41,33.2,39.6,33.2z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.837b067683f0888d9a31a7507c4356db.svg";
export { ForwardRef as ReactComponent };